import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';
import { useAlert, types } from 'react-alert';
import { PageTitle, PaperWithTitle, PagingTable } from '../../../components';
import { useClinicUser, useChat } from '../../../../model/hooks';
import { getLabelFromString } from '../../../common/helper';
import { Utils } from '../../../../common/helper';
import { Job } from '../../../../model/firestore_model';
export const ChatList = () => {
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const history = useHistory();
    const { jobClinic } = useClinicUser();
    const { columns, loading, loadChatList } = useChat();
    const [rows, setRows] = useState([]);
    const [listeners, setListeners] = useState([]);
    const loadData = (lastDocument) => {
        const listener = loadChatList(async (myRooms) => {
            if (myRooms.length === 0)
                return;
            const promises = myRooms.map(async (myRoom) => {
                var _a, _b, _c, _d, _e;
                const worker = await Job.User.get((_a = myRoom.members) === null || _a === void 0 ? void 0 : _a.workerId);
                return {
                    id: myRoom.id,
                    userId: (_b = myRoom.members) === null || _b === void 0 ? void 0 : _b.workerId,
                    userName: getLabelFromString((_c = worker) === null || _c === void 0 ? void 0 : _c.fullName()),
                    userImage: (_d = worker) === null || _d === void 0 ? void 0 : _d.image,
                    latestMessage: getLabelFromString((_e = myRoom.latestMessage) === null || _e === void 0 ? void 0 : _e.text),
                    unreadCount: myRoom.unreadCount,
                    detail: myRoom,
                };
            });
            let _rows = await Promise.all(promises);
            setRows(rows.concat(_rows));
        }, lastDocument);
        listeners.push(listener);
        setListeners(listeners);
    };
    const onMore = () => {
        if (rows.length > 0) {
            const lastRow = rows.slice(-1)[0];
            loadData(lastRow.detail.snapshot);
        }
    };
    useEffect(() => {
        return () => listeners.forEach((listener) => listener());
    }, [listeners]);
    useEffect(() => {
        const f = () => {
            try {
                loadData();
            }
            catch (e) {
                if (e instanceof Error) {
                    reactAlert.show(e.message, { type: types.ERROR });
                }
            }
        };
        if (Utils.isNotNull(jobClinic)) {
            f();
        }
    }, [jobClinic]);
    const onClickContent = (id) => history.push(`/home/chat_list/${id}`);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('やりとり一覧')),
        React.createElement(SGrid, { container: true },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PaperWithTitle, { title: t('ルーム一覧') },
                    React.createElement(PagingTable, { columns: columns, rows: rows, loading: loading, onClickExpandMore: onMore, onClickContent: onClickContent }))))));
};
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
